export const REFUND_STATUSES: any = {
  RETURN: 'REGL. RETOURNE',
  VISITE: 'CONTRE VISITE',
  AGREEMENT: 'A C C O R D',
  REJECTED: 'REJETE',
  PAIED: 'REGLE',
  PEC_CANCELED: 'P.E.C ANNULEE',
  PENDING: 'EN COURS',
  COMPLEMENTARY_INFO: 'COMPLEMENT INFO',
  PEC: 'PRISE EN CHARGE',
  S_SUITE: 'CLOTURE S.SUITE',
};

export const REQUESTS_STATUSES: any = {
  CREATED: 'CRÉÉE',
  VALIDATED: 'VALIDÉE',
  REJECTED: 'REJETÉE',
};
